<div
  class="switch"
  [class.active]="ngModel"
  (click)="onChange()"
>
  <div class="handle"></div>
</div>
